import * as types from '@/store/mutation-types'
import WebsitesWidgetsServiceClient from '@/clients/websites-widgets/WebsitesWidgetsServiceClient'
import Location from '@/entities/Location'
import { trackInDatadog } from '@/utilities/track-error'

/**
 * @param {Function} commit
 * @param {Array} rootGetters
 * @param {String} slug
 * @returns {Array} customWidgetSettings
 */
export const getCustomWidgetSettings = ({ commit }) => {
  const websiteWidgetsServiceClient = new WebsitesWidgetsServiceClient()

  return websiteWidgetsServiceClient.getCustomWidgetSettings()
    .then(({ data }) => {
      if (data.data.length) {
        commit(types.SET_WIDGET_SETTINGS, data.data)
        commit(types.SET_WIDGETS, data.data)
      }
    })
    .catch((error) => {
      trackInDatadog('actions/getCustomWidgetSettings', error, { practiceUuid: websiteWidgetsServiceClient.practiceUuid })
      return Promise.reject(new Error(error.message))
    })
}

/**
 * @param {Function} commit
 * @param {Array} rootGetters
 * @returns {Array} widgetManagerSettings
 */

export const getWidgetManagerSettings = ({ commit }) => {
  const websiteWidgetsServiceClient = new WebsitesWidgetsServiceClient()

  return websiteWidgetsServiceClient.getWidgetManagerSettings()
    .then(({ data }) => {
      if (data.data.locations?.length) {
        commit(types.SET_PRACTICE_LOCATIONS, data.data.locations.map(location => (new Location(location))))
      }
    })
    .catch((error) => {
      trackInDatadog('actions/getWidgetManagerSettings', error, { practiceUuid: websiteWidgetsServiceClient.practiceUuid })
      return Promise.reject(new Error(error.message))
    })
}
